import React from "react";
import productsData from "../../data/seccochimneys.json";
import ProductRangeLayout from "../../components/ProductRangeLayout";

function SeccoChimneys() {
	return (
		<ProductRangeLayout
			sectionTitle="Chimneys & Roof Vent"
			sectionSubtitle="Versatile, sturdy, and insulating!"
			sectionBody={[
				"SKOV-SECCO offers multiple variants and sizes of chimneys for livestock houses. All of them are insulated and light.",
				"All plastic products manufactured by SKOV-SECCO are made of sturdy and non-corrosive UV-treated High-Density Polyethylene (H.D.P.E.) plastic.",
			]}
			products={productsData}
		/>
	);
}

export default SeccoChimneys;
